export default {
  loadedChart: false,
  username: '',
  chartId: '',
  teamId: '',
  loadedEditChartBtn: false,
  isFeedbackFormActive: false,
};
